module.exports = __webpack_public_path__ + "img/G0.273f6fc2.png";